import { useState, useEffect } from 'react'
import { withRouter } from 'react-router'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { Grid, Paper, IconButton, InputBase, Divider, Menu, MenuItem, Button } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import { screenSizes } from 'shared/styles/theme'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import history from 'modules/app/components/history'
import { get_menu_data } from 'modules/api/market-api'

const ITEM_HEIGHT = 48;

const Header = (props: any) => {
  const location = useLocation();
  const [ searchValue, setSearchValue ] = useState('')
  const [ current_url, setCurrentUrl ] = useState('')
  
  const [anchorEl, setAnchorEl] = useState<any>(null)
  const [ menu_data, setMenuData ] = useState<any>([])

  useEffect(() => {
    (async () => {
      let menu_data_result = await get_menu_data()
      // console.log(menu_data_result.menu_data)
      setMenuData(menu_data_result.menu_data)
    })()
      
  }, [])
  
  useEffect(() => {
    setCurrentUrl(location.pathname)
  }, [location])

  const handleClose = () => {
      setAnchorEl(null);
  };

  const handleClick = (index: number, event: React.MouseEvent<HTMLElement>, btnText: string) => {
      setAnchorEl({ [index]: event.currentTarget });
  };

  const changeProduct = (product: any) => {
      setAnchorEl(null);
 
      let product_url = product.toLowerCase().split(' ').join('-')
      history.push(`/${product_url}`)
  }

  const goStartPage = () => {
      history.push(`/`)
  } 

  return (
    <>
      {
        current_url === '/admin' ? <></>
        : 
        current_url === '/admin/products' ? <></>
        : 
        current_url === '/admin/signin' ? <></>
        : 
        current_url === '/quiz/list/all' ? <></>
        :
        current_url.startsWith('/quiz/') === true ? <></>
        :
        current_url === '/admin/quiz' ? <></>
        :
        current_url === '/admin/quiz-analyze' ? <></>
        :
        current_url === '/admin/quiz-analyze-users' ? <></>
        :
        current_url === '/admin/data' ? <></>
        :
        current_url === '/admin/examples-for-finetuning-training' ? <></>
        :
        <>
            <HeaderContainer>
              <CustomGrid container spacing={0} sx={{padding: '10px 0 8px', height: '64px'}}>
                <CustomGrid item xs={2} className="grid-header-left" >
                  
                </CustomGrid>
                <CustomGrid item xs={8} className="header_logo" onClick={goStartPage} >
                  <img src={require('assets/logo_avatar_05.png').default} style={{width: '52px!important'}} alt="" />
                  {/* &nbsp;<span><BoldSpan>US </BoldSpan><BoldSpan>R</BoldSpan>atings</span> */}
                </CustomGrid>

                <CustomGrid item xs={2} className="grid-header-left" >
                  <div className='categories_link_wrapper'>
                    <a href="/categories" className='categories_link' style={{paddingRight: 0}}>Categories</a>
                  </div>
                </CustomGrid>
              </CustomGrid>
            </HeaderContainer>
        </>
      }
    </>
    

  )
}

const CustomInputBase = styled(InputBase)`
  input.css-yz9k0d-MuiInputBase-input { 
    background-color: #0000000a!important;
    padding: 10px 20px!important;
    border-radius: 30px!important;
  }
`

const CustomIconButton = styled(IconButton)`
  &.css-1gtpq4r-MuiButtonBase-root-MuiIconButton-root {
    background-color: #0000000a!important;
  }
  &.css-1gtpq4r-MuiButtonBase-root-MuiIconButton-root:hover {
    background-color: #0000000a!important;
  }
`

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 8px;
  position: fixed;
  width: 100%;
  z-index: 100;

  align-items: center;
    @media (max-width: ${screenSizes.mediaM}px) {
      display: none;
    }
`
const BoldSpan = styled.span`
  font-weight: 700;
`

const CustomButton = styled(Button)`
`
const CustomeMenu = styled(Menu)`
`
const DropDownDiv = styled.div`
    ${CustomButton} {
        font-family: GT Pressura,sans-serif;
        font-weight: 600;
        line-height: 1.33;
        font-size: 24px;
        letter-spacing: 0.03em;
        color: #000;
        background-color: transparent;

        &:hover {
            background-color: #1e947e;
            // background-color: #37a4f1;
            color: white;
        }
    }

`
const CustomGrid = styled(Grid)`
  background-color: white!important;
  padding: 8px 20px;
  margin: 0px!important;

  div.categories_link_wrapper {
    display: flex;
    align-items: center;
  }

  a.categories_link {
    color: #000;
    font-size: 14px;
    font-family: GT Pressura, sans-serif;
    font-weight: 600;
    padding: 8px 10px;
    text-decoration: none;
    display: block;
    text-decoration: none !important;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    outline: none;
  }

  .header_logo{
    display: flex;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
    justify-content: center;
  }

  img {
    // width: 192px;
    // height: 48px;
    // width: 25px;
    // height: 25px;
    width: 110px;
    height: 40px;
  }

  .grid-flex-item-end {
    display: flex;
    justify-content: space-between;
  }

  .grid-flex-item-start {
    display: flex;
    justify-content: start;
    ${DropDownDiv} {
        margin: 0 5px;
    }
  }

  .grid-header-left {
    @media (min-width: ${screenSizes.mediaXLL}px) {
      // padding-left: 105px!important;
    }
    @media (min-width: ${screenSizes.mediaXXL}px) {
      // padding-left: 155px!important;
    }
    @media (min-width: ${screenSizes.mediaXXXX}px) {
      // padding-left: 185px!important;
    }

    display: flex;
    justify-content: flex-end;

  }

  .grid-header-right {
    @media (min-width: ${screenSizes.mediaXLL}px) {
      // padding-right: 105px;
    }
    @media (min-width: ${screenSizes.mediaXXL}px) {
      // padding-right: 155px;
    }
    @media (min-width: ${screenSizes.mediaXXXX}px) {
      // padding-right: 185px;
    }
  }
`

export default withRouter(Header)
